import { Container, Row, Col } from 'reactstrap'
import styled from 'styled-components'

const Footer = () => (
    <StyledHeader className='footer1 footer-page'>
        <Container fluid>
            <Row>
                <Col md={6} sm={12} className='text-left res-foot'>
                    {' '}
                    Copyright © {new Date().getFullYear()} Club Management. All rights reserved.
                </Col>
                <Col md={4} sm={12} className='text-left res-foot'>
                    <a href='/terms_conditions' className='text-white'>Website Terms and Conditions</a>
                </Col>
                <Col md={2} sm={12} className='text-right res-foot'>
                    <a href='mailto:support@easy2show.com' className='text-white'>Contact Us</a>
                </Col>
            </Row>
        </Container>
    </StyledHeader>
)

export default Footer
const StyledHeader = styled.footer`
    left: 0px !important;
`